// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-mask_wrapper__Ppdvy","label":"text-mask_label__bRI_d","helper_text":"text-mask_helper_text__4CiQI","input":"text-mask_input__GL6Kf","error":"text-mask_error__gD3CJ"};